(() => {
  const SECTION_SELECTOR = [
    '[id$="__halloween_products"]',
    '[id$="__shop_by_pet"]',
    '[id$="__new_arrivals"]',
    '[id$="__popular_picks"]',
    '[id$="__happier_pet_solutions"]'
  ].join(',');

  const AUTOPLAY_DELAY = 5000;
  const RESUME_DELAY = 8000;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initialise = (section) => {
    if (!section || section.dataset.tailclawCarouselReady === 'true') return;

    const sliderComponent = section.querySelector('slider-component');
    const viewport = sliderComponent && sliderComponent.querySelector('.slider');
    const slides = viewport && viewport.querySelectorAll('.slider__slide');
    const nextButton = sliderComponent && sliderComponent.querySelector('.slider-button--next');

    if (!viewport || !slides || slides.length < 2) return;

    section.dataset.tailclawCarouselReady = 'true';

    let timer;
    let resumeTimer;
    let paused = false;

    const clearTimers = () => {
      window.clearTimeout(timer);
      window.clearTimeout(resumeTimer);
    };

    const canMove = () => viewport.scrollWidth - viewport.clientWidth > 4;

    const schedule = (delay = AUTOPLAY_DELAY) => {
      window.clearTimeout(timer);
      if (paused || document.hidden || reducedMotion.matches || !canMove()) return;
      timer = window.setTimeout(advance, delay);
    };

    const restartAfterInteraction = () => {
      clearTimers();
      paused = true;
      resumeTimer = window.setTimeout(() => {
        paused = false;
        schedule();
      }, RESUME_DELAY);
    };

    const advance = () => {
      if (paused || document.hidden || reducedMotion.matches || !canMove()) {
        schedule();
        return;
      }

      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      const atEnd = viewport.scrollLeft >= maxScroll - 4;

      if (atEnd || (nextButton && nextButton.disabled)) {
        viewport.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (nextButton) {
        nextButton.click();
      } else {
        const firstLeft = slides[0].offsetLeft;
        const current = viewport.scrollLeft;
        const nextSlide = Array.from(slides).find(
          (slide) => slide.offsetLeft - firstLeft > current + 4
        );
        viewport.scrollTo({
          left: nextSlide ? nextSlide.offsetLeft - firstLeft : 0,
          behavior: 'smooth'
        });
      }

      schedule();
    };

    section.addEventListener('mouseenter', () => {
      paused = true;
      window.clearTimeout(timer);
    });

    section.addEventListener('mouseleave', () => {
      paused = false;
      schedule();
    });

    section.addEventListener('focusin', () => {
      paused = true;
      window.clearTimeout(timer);
    });

    section.addEventListener('focusout', (event) => {
      if (!section.contains(event.relatedTarget)) {
        paused = false;
        schedule();
      }
    });

    section.addEventListener('pointerdown', restartAfterInteraction, { passive: true });
    viewport.addEventListener('scroll', () => schedule(), { passive: true });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        window.clearTimeout(timer);
      } else {
        schedule();
      }
    });
    reducedMotion.addEventListener?.('change', () => schedule());

    schedule();
  };

  const initialiseAll = (root = document) => {
    if (root.matches?.(SECTION_SELECTOR)) initialise(root);
    root.querySelectorAll?.(SECTION_SELECTOR).forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
